// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var PromiseUtils$SmartcutsMacros = require("../../../bs-utils/src/PromiseUtils.bs.js");
var CommandContext$SmartcutsMacros = require("../CommandContext.bs.js");
var Browser__Windows$SmartcutsMacros = require("../browser/Browser__Windows.bs.js");
var PlaybackBridge__OS$SmartcutsMacros = require("../PlaybackBridge__OS.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("../InterfaceBtwnRecordingAndPlayback.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "windowRef",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
              ],
              [
                "focusStatus",
                CommandContext$SmartcutsMacros.focusStatus_encode(v.focusStatus)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
  if (windowRef.TAG === /* Ok */0) {
    var focusStatus = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
    if (focusStatus.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                windowRef: windowRef._0,
                focusStatus: focusStatus._0
              }
            };
    }
    var e = focusStatus._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".focusStatus" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = windowRef._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".windowRef" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  return "{windowRef: '" + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.stringify(param.windowRef) + ("', focusStatus: " + (CommandContext$SmartcutsMacros.stringifyFocusStatus(param.focusStatus) + "}")));
}

var CommandValue = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function execute(playbackOptions, contextGlobal, playbackBridgeOs, param) {
  var focused = playbackOptions.doNotFocus ? false : param.focusStatus === /* Focused */0;
  var match = contextGlobal.windowGeometry;
  var arg = match.width;
  var arg$1 = match.height;
  var arg$2 = focused;
  var arg$3 = function (param, param$1, param$2, param$3) {
    return Curry.app(PlaybackBridge__OS$SmartcutsMacros.createWindowWithNoUrl, [
                param,
                param$1,
                param$2,
                arg,
                arg$1,
                arg$2,
                param$3,
                "normal",
                "normal"
              ]);
  };
  return Curry._2(arg$3(undefined, undefined, undefined, undefined), undefined, playbackBridgeOs).then(function (param) {
              var nextPlaybackBridgeOs = param[1];
              var $$window = param[0];
              return PromiseUtils$SmartcutsMacros.resolveWith((function (onlyTab) {
                            return [
                                    $$window,
                                    onlyTab,
                                    nextPlaybackBridgeOs
                                  ];
                          }), Browser__Windows$SmartcutsMacros.Helpers.getOnlyTabOfWindow($$window));
            });
}

var CommandControlBg = {
  execute: execute
};

exports.CommandValue = CommandValue;
exports.CommandControlBg = CommandControlBg;
/* PromiseUtils-SmartcutsMacros Not a pure module */
